import classNames from 'classnames';
import { ButtonNavigationComponent } from 'components/1-atoms';
import { ButtonComponentProps } from 'components/1-atoms/ButtonComponent/ButtonComponent';
import { useEffect, useState } from 'react';
import { FieldErrors, FieldValues, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { useAppSelector } from 'store/hooks';
import { isReceiptStepByPageId } from '../../../services/PackageService';
import styles from './CtaComponent.module.scss';

interface CtaButtonComponentProps extends Omit<ButtonComponentProps, 'linkButtonSettings'> {
	buttonActionType?: 'submit' | 'button';
	linkButtonSettings?: { url: string };
}

export interface CtaGroupComponentProps {
	ctaSubmitStep?: () => Promise<void>;
	errors?: FieldErrors<FieldValues>;
	errorMessage?: string;
	isValid?: boolean;
	isPackageStep?: boolean;
	pageId: string;
	setValue?: UseFormSetValue<FieldValues>;
	trigger?: UseFormTrigger<FieldValues>;
	hasError?: boolean;
	beforeSubmit?: () => void;
	ctaGroup: {
		items: {
			content: CtaButtonComponentProps;
		}[];
	};
}
export const CtaGroupComponent: React.FC<CtaGroupComponentProps> = ({
	ctaGroup,
	ctaSubmitStep,
	errors,
	errorMessage,
	isValid,
	isPackageStep,
	pageId,
	setValue,
	trigger,
	hasError,
	beforeSubmit,
}) => {
	const [hasSubmitError, setHasSubmitError] = useState(hasError);
	const { orderedPageList } = useAppSelector((state) => state.pages);
	const [backButton, setBackButton] = useState<CtaButtonComponentProps>();
	const [forwardButton, setForwardButton] = useState<CtaButtonComponentProps>();

	const showBackButton = () => {
		return (
			backButton &&
			Number.parseInt(pageId) !== orderedPageList[0] &&
			!isReceiptStepByPageId(Number.parseInt(pageId))
		);
	};

	const onCtaSubmit = async () => await ctaSubmitStep();

	useEffect(() => {
		if (ctaGroup.items) {
			for (const button of ctaGroup.items) {
				if (button.content.buttonActionType === 'submit') {
					setForwardButton(button.content);
				} else {
					setBackButton(button.content);
				}
			}
		}
	}, []);

	useEffect(() => {
		if (!errors) {
			return;
		}
		const hasError = Object.keys(errors)?.length > 0 && errorMessage !== undefined;
		setHasSubmitError(hasError);
	}, [errors]);

	return (
		<>
			{hasSubmitError && (
				<p
					role='alert'
					className={styles.ctaComponent__error}
				>
					{errorMessage}
				</p>
			)}
			{
				<div
					className={classNames(
						styles.ctaComponent__navigation,
						isPackageStep && styles.ctaComponent__navigation__package,
						!showBackButton() && styles.ctaComponent__navigation__single_button
					)}
				>
					{showBackButton() && (
						<ButtonNavigationComponent
							isSubmit={false}
							isValid={true}
							pageId={Number.parseInt(pageId)}
							label={ctaGroup.items[0].content?.label || 'Tilbage'}
							isPackage={isPackageStep}
						/>
					)}
					{forwardButton && (
						<ButtonNavigationComponent
							isSubmit={true}
							submit={isPackageStep ? undefined : onCtaSubmit}
							isValid={isValid}
							pageId={Number.parseInt(pageId)}
							label={forwardButton.label || 'Fortsæt'}
							trigger={isPackageStep ? undefined : trigger}
							setValue={isPackageStep ? undefined : setValue}
							url={forwardButton.linkButtonSettings?.url}
							beforeSubmit={beforeSubmit}
							isPackage={isPackageStep}
						/>
					)}
					{''}
				</div>
			}
		</>
	);
};
